import { useTranslation } from "react-i18next";
import { SeAttachmentSource } from "../../../autogen/bff-api";

// Mirrors the file types the BFF accepts (UploadService.parseMimeType). Used for an inline,
// pre-upload check so the user sees a friendly message instead of a failed request.
export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "jpg",
  "jpeg",
  "png",
];

export const isAllowedAttachmentFile = (fileName: string): boolean => {
  const extension = fileName.includes(".") ? fileName.split(".").pop()?.toLowerCase() ?? "" : "";
  return ALLOWED_ATTACHMENT_EXTENSIONS.includes(extension);
};

export const useAttachmentSourceLabel = (): ((source: SeAttachmentSource) => string) => {
  const { t } = useTranslation();
  return (source: SeAttachmentSource) => {
    switch (source) {
      case SeAttachmentSource.Request:
        return t("From the request");
      case SeAttachmentSource.Offer:
        return t("From the tender");
      case SeAttachmentSource.Upload:
        return t("Uploaded");
    }
  };
};
